var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92.141,
    height: 113.749,
    viewBox: "0 0 92.141 113.749"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_126",
    "data-name": "Groupe 126",
    transform: "translate(-268.993 -577.74)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OK",
    transform: "translate(-631 117.633)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\xE9_1928",
    "data-name": "Trac\xE9 1928",
    d: "M-8676.949,108.975l9.7,12.327,18.3-23",
    transform: "translate(9607.949 404.065)",
    fill: "none",
    stroke: "#3691d0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\xE9_1932",
    "data-name": "Trac\xE9 1932",
    d: "M904.418,504.745s2.318,29.686,30.672,29.686,30.674-21.5,30.674-29.686-2.693-36.213-30.674-36.213",
    transform: "translate(1489.248 1424.828) rotate(-149)",
    fill: "none",
    stroke: "#3691d0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_124",
    "data-name": "Groupe 124",
    transform: "translate(334.39 688.531) rotate(-150)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 2.5,
    cy: 2.5,
    rx: 2.5,
    ry: 2.5,
    transform: "translate(3.37 14.219)",
    fill: "#3691d0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 2.5,
    cy: 2.5,
    rx: 2.5,
    ry: 2.5,
    transform: "translate(12.303 14.219)",
    fill: "#3691d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\xE9_175",
    "data-name": "Trac\xE9 175",
    d: "M0,9C1.4,3.78,5.5,0,10.337,0s8.933,3.78,10.337,9",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#3691d0",
    strokeLinecap: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\xE9_1929",
    "data-name": "Trac\xE9 1929",
    d: "M1718.286,2883.6s-2.023-5.058-7.2-6.084",
    transform: "translate(-1436 -2284)",
    fill: "none",
    stroke: "#3691d0",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\xE9_1930",
    "data-name": "Trac\xE9 1930",
    d: "M1711.089,2886.642s3.036-7.591,10.8-9.129",
    transform: "translate(-3061.514 399.428) rotate(-56)",
    fill: "none",
    stroke: "#3691d0",
    strokeLinecap: "round",
    strokeWidth: 4
  }))));
};

export default __webpack_public_path__ + "static/media/validationMail.845e7401.svg";
export { SvgComponent as ReactComponent };